import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_RECIPIENTS_STATE } from '../../../constants/createSendRecipients';
import { ICreateSendRecipient, ICreateSendRecipientsState } from '../../../types/createSendRecipients';
import * as AuthActions from '../../actions/auth';
import * as CreateSendRecipientsActions from '../actions/recipients';

export const initialState: ICreateSendRecipientsState = DEFAULT_CREATE_SEND_RECIPIENTS_STATE;

const reducer = (state: ICreateSendRecipientsState = initialState, action: any): ICreateSendRecipientsState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT:
    case CreateSendRecipientsActions.RESET_CS_RECIPIENTS: {
      return initialState;
    }
    case CreateSendRecipientsActions.SET_CS_ADDRESS_MODE: {
      return { ...state, addressMode: action.payload };
    }
    case CreateSendRecipientsActions.SET_CS_CLAIM_LINK_MODE: {
      return { ...state, claimLinkMode: action.payload };
    }
    case CreateSendRecipientsActions.SET_CS_MULTI_KIT_ADDRESS_MODE: {
      return { ...state, multiKitAddressMode: action.payload };
    }
    case CreateSendRecipientsActions.CS_ADD_RECIPIENT: {
      return { ...state, recipients: [...state.recipients, action.payload] };
    }
    case CreateSendRecipientsActions.CS_UPDATE_RECIPIENT: {
      const { uid, patch } = action.payload as { uid: string; patch: Partial<ICreateSendRecipient> };

      return {
        ...state,
        recipients: state.recipients.map((recipient) =>
          recipient.uid === uid ? { ...recipient, ...patch } : recipient,
        ),
      };
    }
    case CreateSendRecipientsActions.CS_REMOVE_RECIPIENT: {
      return { ...state, recipients: state.recipients.filter((recipient) => recipient.uid !== action.payload) };
    }
    case CreateSendRecipientsActions.CS_CLEAR_RECIPIENTS: {
      return { ...state, recipients: [] };
    }
    case CreateSendRecipientsActions.CS_SET_RECIPIENTS: {
      return { ...state, recipients: action.payload };
    }
    case CreateSendRecipientsActions.SET_CS_OVERRIDE_ADDRESS: {
      return { ...state, overrideAddress: action.payload };
    }
    case CreateSendRecipientsActions.SET_CS_ONE_TIME_ADDRESS: {
      return { ...state, oneTimeAddress: action.payload };
    }
    case CreateSendRecipientsActions.SET_CS_CLAIM_ADDRESS_IDS: {
      return { ...state, selectedClaimAddressIds: action.payload };
    }
    default:
      return state;
  }
};

export default reducer;
